import { portSchema, portSchemaRequired, portSchemaStrict } from '#schemas/general/port.ts';

export const lighthouseDNSOnPortSchema = portSchemaRequired;
export const lighthouseDNSOffPortSchema = portSchema;
export const lighthouseDNSStrictPortSchema = portSchemaStrict;
